import React from 'react';
import {Route, Switch} from 'react-router-dom';
import NavBarLugar from '../Components/NavBarLugar';
import Footer from '../Components/Footer';
import './layout.scss';

export default function LayoutLugar(props) {
    const {routes} = props;
    return (
      <div>
       <NavBarLugar/>
        <LoadRoutes routes={routes}/>  
       <Footer/> 
      </div>
    )
  }
  
  
  function LoadRoutes({ routes }) {
    return ( 
    <Switch> {
            routes.map((route, index) => (
                 <Route key = { index }
                 path = { route.path }
                 exact = { route.exact }
                 component = { route.component }
                />
            ))
        } 
        </Switch>
    );
  
  }